import { render, staticRenderFns } from "./CandidatesWaitPage.vue?vue&type=template&id=55682ebe&scoped=true&lang=pug"
import script from "./CandidatesWaitPage.vue?vue&type=script&lang=js"
export * from "./CandidatesWaitPage.vue?vue&type=script&lang=js"
import style0 from "./CandidatesWaitPage.vue?vue&type=style&index=0&id=55682ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55682ebe",
  null
  
)

export default component.exports